import { BaseeSearchClass } from '../../../../Shared-Lib/model/search-result';
import { SelectListItem } from '../lib/select/select-property'
import { DialogService } from '../../../../Shared-Lib/component/dialog/dialog.service';
import * as t from '../lib/select/select-service';
import { Router } from '@angular/router';
import { DataService } from '../../../../Shared-Lib/services/data.service';

const ControllerName: string = 'Menu';

//search filter request api fields
export class SearchClass extends BaseeSearchClass {
  MenuPID?: string;
  MenuTitle?: string;
  IsDisplayed?: string;
  Inclusive? : any;
}

//structure of table for postback api
export class Menu {
    Parent?: string;
    MenuID?: string;
    MenuPID?: string;
    MenuTitle?: string;
    MenuLink?: string;
    MenuBreadcrumb?: string;
    OrderSeq?: string;
    IsEnabled?: boolean;
    MenuIcon?: string;
    IsDisplayed?: boolean;
}

/** Menu Search class */
export class Menu_Search  {
  filter: SearchClass;
  ddlInclude?: SelectListItem[];
  ddlDisplay?: SelectListItem[];
  ddlParent?: SelectListItem[];
  SelectedInclude?: any;
  SelectedDisplay?: any;

  constructor() {
    this.filter = new SearchClass();
    this.filter.MenuPID = '';
    this.filter.MenuTitle = '';
    this.filter.IsDisplayed = '';
    this.ddlInclude = t.GetItems(t.Items.Options_Enabled, false);
    this.ddlDisplay = t.GetItems(t.Items.Options_Enabled, true);    
    this.filter.Inclusive = 0;
  }
}

/** document edit/create page models */
export class Menu_Document extends Menu {
  ddlEnabled?: SelectListItem[];
  ddlDisplay?: SelectListItem[];
  ddlParent?: SelectListItem[];
  SelectedEnabled?: any;
  SelectedDisplay?: any;

  // CurrentUser: any;
  constructor(private _dlgService: DialogService, private router: Router, private dataService: DataService) {
    super();
    this.ddlDisplay = t.GetItems(t.Items.Options_Enabled);
}

    GetDocument(uid: string) {
      this.dataService.getData(`${ControllerName}/${uid}`, null, (ret) => {
          this.MenuID = ret.MenuID;
          this.MenuPID = ret.MenuPID;
          this.MenuTitle = ret.MenuTitle;
          this.MenuLink = ret.MenuLink;
          this.MenuBreadcrumb = ret.MenuBreadcrumb;
          this.OrderSeq = ret.OrderSeq;
          this.MenuIcon = ret.MenuIcon;
          this.IsEnabled = ret.IsEnabled;
          this.IsDisplayed = ret.IsDisplayed;
          this.SelectedEnabled = ret.IsEnabled ? 1 : 0;
          this.SelectedDisplay = ret.IsDisplayed ? 1 : 0;
      });
  }
}
